var exports = {
  "kL": "xa15a2ab7--8060f1--container",
  "DD": "xa15a2ab7--8060f1--title",
  "lp": "xa15a2ab7--8060f1--preloader-wrapper",
};

module.exports = exports;
